import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { ReferenceDataConstants } from '../../../lib/constants/reference-data-constants';
import { ReferenceDataLabels } from '../../../lib/constants/reference-data-labels';
import { ReferenceDataOptionLists } from '../../../lib/constants/reference-data-option-lists';
import { CaseSetupDto } from '../../../lib/models/dto/case-setup-dto.model';
import { OptionListItemDto } from '../../../lib/models/dto/option-list-item-dto';
import { CaseSetupService } from '../../services/case-setup.service';

@Component({
  selector: 'boi-add-case',
  templateUrl: './add-case.component.html',
  styleUrls: ['./add-case.component.scss']
})
export class AddCaseComponent implements OnInit, OnDestroy {
  private readonly MAXIMUM_NUMBER_OF_APPLICANTS = 4;
  private readonly destroy$ = new Subject();

  public readonly referenceDataLabels = ReferenceDataLabels;
  public readonly referenceDataConstants = ReferenceDataConstants;
  public readonly referenceDataOptionLists = ReferenceDataOptionLists;

  public readonly namePattern = /^[a-zA-Z \-']*$/;

  public numberOfApplicantsRange = [];
  public whereDidUserHearAboutUsOptions: Array<OptionListItemDto> = [];

  @Input() public caseSetup: CaseSetupDto;

  @Output() public readonly isValid = new EventEmitter<boolean>();

  constructor(private readonly caseSetupService: CaseSetupService) {}

  ngOnInit(): void {
    this.numberOfApplicantsRange = Array(this.MAXIMUM_NUMBER_OF_APPLICANTS)
      .fill(0)
      .map((_, index) => index + 1);

    this.caseSetup.IsRemortgage = this.translateRemortgageOption();

    this.caseSetupService
      .getWhereDidUserHearAboutProductOptions(
        this.caseSetup.PropositionID.toString(),
        this.caseSetup.InterfaceTypeID.toString()
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe((options) => {
        this.whereDidUserHearAboutUsOptions = options;
      });
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public selectNumberOfApplicants(numberOfApplicants: number): void {
    this.caseSetup.NumberOfApplicants = numberOfApplicants;

    this.formValueChanged();
  }

  public formValueChanged(): void {
    this.isValid.emit(this.checkValidity());
  }

  private translateRemortgageOption(): string {
    return this.caseSetup.IsRemortgage === this.referenceDataOptionLists.AnswerTypeYes
      ? this.referenceDataOptionLists.PurchaseOrRemortgageRemortgage
      : this.referenceDataOptionLists.PurchaseOrRemortgagePurchase;
  }

  private checkValidity(): boolean {
    if (
      !this.caseSetup.PropertyLocation ||
      !this.caseSetup.WhereDidUserHearAboutProduct ||
      !this.caseSetup.Surname ||
      !this.caseSetup.Surname.trim() ||
      !this.caseSetup.Forename ||
      !this.caseSetup.Forename.trim()
    ) {
      return false;
    }

    return true;
  }
}
